import React from "react"

import { ProductConfiguratorContextProvider } from "widgets/product-configurator/model/ProductConfiguratorContext"

import { ProductConfigurationOverlayView } from "./ProductConfigurationOverlayView"
import { ProductConfigurationOverlayModel } from "./hooks/useProductConfigurationOverlayModel"
import { useProductConfigurationOverlayViewModel } from "./hooks/useProductConfigurationOverlayViewModel"

export interface ProductConfigurationOverlayProps
  extends ProductConfigurationOverlayModel {}

function ProductConfigurationOverlayInner(
  props: ProductConfigurationOverlayProps
) {
  return (
    <ProductConfigurationOverlayView
      {...useProductConfigurationOverlayViewModel(props)}
    />
  )
}

function ProductConfigurationOverlayComponent(
  props: ProductConfigurationOverlayProps
) {
  const { productConfiguratorModel } = props
  return (
    <ProductConfiguratorContextProvider model={productConfiguratorModel}>
      <ProductConfigurationOverlayInner {...props} />
    </ProductConfiguratorContextProvider>
  )
}

export const ProductConfigurationOverlay = React.memo(
  ProductConfigurationOverlayComponent
) as typeof ProductConfigurationOverlayComponent
